import * as React from 'react';

import { WalkScoreViewModel, WhatsAroundModuleViewModel } from 'models';

import { NearbyList } from './nearby-list';
import { NearbyPOIs } from './nearby-pois';
import { NearbyRestaurants } from './nearby-restaurants';
import { NearbyTransportation } from './nearby-transportation';

interface WhatsAroundContentProps {
  model?: WhatsAroundModuleViewModel;
  walkScoreModel?: WalkScoreViewModel;
}

export const WhatsAroundContent: React.FunctionComponent<WhatsAroundContentProps> = ({ model, walkScoreModel }) => {
  const nearbyPOIs = model.nearbyPOIs && model.nearbyPOIs.length >= 1;
  const nearbyTransportation = model.nearbyTransportation && model.nearbyTransportation.length >= 1;
  const nearbyRestaurants = model.restaurants && model.restaurants.length >= 1;

  return (
    <>
      {nearbyPOIs && (
        <NearbyList
          outerClass="all-y-padding-three all-x-padding-three"
          title={model.subtitlePOIs}
          category="place"
          accessibleCategory={model.nearbyPOIs[0].accessibleCategory}
          walkScoreModel={walkScoreModel}
        >
          <NearbyPOIs nearbyPOIsList={model.nearbyPOIs} />
        </NearbyList>
      )}
      {nearbyTransportation && (
        <NearbyList outerClass="all-y-padding-three all-x-padding-three" title={model.subtitleTransportations} category="directions_car">
          <NearbyTransportation nearbyTransportationList={model.nearbyTransportation} />
        </NearbyList>
      )}
      {nearbyRestaurants && (
        <NearbyList outerClass="all-y-padding-three all-x-padding-three" title={model.subtitleRestaurants} category="local_dining">
          <NearbyRestaurants nearbyRestaurantsList={model.restaurants} />
        </NearbyList>
      )}
    </>
  );
};

WhatsAroundContent.displayName = 'WhatsAroundContent';
